import { animation } from "./_animation";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { customSplide } from "./splide";
import { accordion } from "./_accordion";
// import { modal } from "./_modal";
// import { tabList } from "./_tab-list";

animation();
common();
drawer();
customSplide();
accordion();
// modal();
// tabList();